export enum ActionType {
    FETCH_BENEFICIARY_DETAILS_START = "FETCH_BENEFICIARY_DETAILS_START",
    FETCH_BENEFICIARY_DETAILS_FAIL = "FETCH_BENEFICIARY_DETAILS_FAIL",
    FETCH_PROFILE_DETAILS_START = "FETCH_PROFILE_DETAILS_START",
    FETCH_PROFILE_DETAILS_SUCCESS = "FETCH_PROFILE_DETAILS_SUCCESS",
    FETCH_PROFILE_DETAILS_FAIL = "FETCH_PROFILE_DETAILS_FAIL",
    FETCH_CONFIG_DETAILS_START = "FETCH_CONFIG_DETAILS_START",
    FETCH_CONFIG_DETAILS_SUCCESS = "FETCH_CONFIG_DETAILS_SUCCESS",
    FETCH_CONFIG_DETAILS_FAIL = "FETCH_CONFIG_DETAILS_FAIL",
    FETCH_BENEFICIARY_DETAILS_SUCCESS = "FETCH_BENEFICIARY_DETAILS_SUCCESS",
    FETCH_ACTIVECLAIM_DETAILS_START = "FETCH_ACTIVECLAIM_DETAILS_START",
    FETCH_ACTIVECLAIM_DETAILS_SUCCESS = "FETCH_ACTIVECLAIM_DETAILS_SUCCESS",
    FETCH_ACTIVECLAIM_DETAILS_FAIL = "FETCH_ACTIVECLAIM_DETAILS_FAIL",
    FETCH_ACTIVECINTIMATION_DETAILS_START = "FETCH_ACTIVECINTIMATION_DETAILS_START",
    FETCH_ACTIVECINTIMATION_DETAILS_SUCCESS = "FETCH_ACTIVECINTIMATION_DETAILS_SUCCESS",
    FETCH_ACTIVECINTIMATION_DETAILS_FAIL = "FETCH_ACTIVECINTIMATION_DETAILS_FAIL",
    FETCH_ENROLMENT_DETAILS_START = "FETCH_ENROLMENT_DETAILS_START",
    FETCH_ENROLMENT_DETAILS_SUCCESS = "FETCH_ENROLMENT_DETAILS_SUCCESS",
    FETCH_ENROLMENT_DETAILS_FAIL = "FETCH_ENROLMENT_DETAILS_FAIL",
    FETCH_SI_PROTECT_START="FETCH_SI_PROTECT_START",
    FETCH_SI_PROTECT_FAIL="FETCH_SI_PROTECT_FAIL",
    FETCH_SI_PROTECT_SUCCESS="FETCH_SI_PROTECT_SUCCESS",
    FETCH_KYC_START="FETCH_KYC_START",
    FETCH_KYC_SUCCESS="FETCH_KYC_SUCCESS",
    FETCH_KYC_FAIL="FETCH_KYC_FAIL",
    FETCH_BANK_DETAIL_START="FETCH_BANK_DETAIL_START",
    FETCH_BANK_DETAIL_SUCCESS="FETCH_BANK_DETAIL_SUCCESS",
    FETCH_BANK_DETAIL_FAIL="FETCH_BANK_DETAIL_FAIL",
    FETCH_MEMBERCONFIG_START="FETCH_MEMBERCONFIG_START",
    FETCH_MEMBERCONFIG_SUCCESS="FETCH_MEMBERCONFIG_SUCCESS",
    FETCH_MEMBERCONFIG_FAIL="FETCH_MEMBERCONFIG_FAIL",
    FETCH_MEMBERDOMIBALANCE_START="FETCH_MEMBERDOMIBALANCE_START",
    FETCH_MEMBERDOMIBALANCE_SUCCESS="FETCH_MEMBERDOMIBALANCE_SUCCESS",
    FETCH_MEMBERDOMIBALANCE_FAIL="FETCH_MEMBERDOMIBALANCE_FAIL",
    FETCH_CLAIMLIST_START="FETCH_CLAIMLIST_START",
    FETCH_CLAIMLIST_SUCCESS="FETCH_CLAIMLIST_SUCCESS",
    FETCH_CLAIMLIST_FAIL="FETCH_CLAIMLIST_FAIL",
    FETCH_HEALTH_BENEFITS_START = "FETCH_HEALTH_BENEFITS_START",
    FETCH_HEALTH_BENEFITS_SUCCESS = "FETCH_HEALTH_BENEFITS_SUCCESS",
    FETCH_HEALTH_BENEFITS_FAIL = "FETCH_HEALTH_BENEFITS_FAIL",
    FETCH_HEALTH_HEALTH_CHECK_PARTNER_START = "FETCH_HEALTH_HEALTH_CHECK_PARTNER_START",
    FETCH_HEALTH_CHECK_PARTNER_BENEFITS = "FETCH_HEALTH_CHECK_PARTNER_BENEFITS",
    FETCH_HEALTH_CHECK_PARTNER_SUCCESS = "FETCH_HEALTH_CHECK_PARTNER_SUCCESS",
    FETCH_HEALTH_CHECK_PARTNER_FAIL = "FETCH_HEALTH_CHECK_PARTNER_FAIL",
    FETCH_VENDOR_URL_START = "FETCH_VENDOR_URL_START",
    FETCH_VENDOR_URL_BENEFITS = "FETCH_VENDOR_URL_BENEFITS",
    FETCH_VENDOR_URL_SUCCESS = "FETCH_VENDOR_URL_SUCCESS",
    FETCH_FLEX_POLCIES_SUCCESS = "FETCH_FLEX_POLCIES_SUCCESS",
    FETCH_VENDOR_URL_FAIL = "FETCH_VENDOR_URL_FAIL",
    FETCH_FLEX_POLCIES_FAIL = "FETCH_FLEX_POLCIES_FAIL",
    FETCH_FLEX_POLICIES_START = "FETCH_FLEX_POLICIES_START",
    FETCH_CORPORATE_CONFIG_START = "FETCH_CORPORATE_CONFIG_START",
    FETCH_CORPORATE_CONFIG_FAIL = "FETCH_CORPORATE_CONFIG_FAIL",
    FETCH_CORPORATE_CONFIG_SUCCESS = "FETCH_CORPORATE_CONFIG_SUCCESS"

}